/**
 * Date utility type definitions
 */

/**
 * Date field mapping for format parsing
 */
export const DATE_FIELD_MAP: Record<string, string> = {
    "G": "era",
    "y": "year",
    "q": "quarter",
    "Q": "quarter",
    "M": "month",
    "L": "month",
    "d": "day",
    "E": "weekday",
    "c": "weekday",
    "e": "weekday",
    "h": "hour",
    "H": "hour",
    "k": "hour",
    "K": "hour",
    "m": "minute",
    "s": "second",
    "a": "dayperiod",
    "t": "dayperiod",
    "x": "zone",
    "X": "zone",
    "z": "zone",
    "Z": "zone"
};

/**
 * Name type configuration for date parts
 */
export interface NameTypeConfig {
    type: string;
    minLength: number | Record<string, number>;
    standAlone?: string;
}

/**
 * Name types for date formatting
 */
export const NAME_TYPES: Record<string, NameTypeConfig> = {
    month: {
        type: "months",
        minLength: 3,
        standAlone: "L"
    },
    quarter: {
        type: "quarters",
        minLength: 3,
        standAlone: "q"
    },
    weekday: {
        type: "days",
        minLength: {
            E: 0,
            c: 3,
            e: 3
        },
        standAlone: "c"
    },
    dayperiod: {
        type: "dayPeriods",
        minLength: 0
    },
    era: {
        type: "eras",
        minLength: 0
    }
};

/**
 * Date format part structure
 */
export interface DateFormatPart {
    type: string;
    pattern: string;
    hour12?: boolean;
    names?: {
        type: string;
        nameType: string;
        standAlone: boolean;
    };
}

/**
 * Options for date format names
 */
export interface DateFormatNamesOptions {
    type: string;
    nameType: string;
}

/**
 * Options for date field name
 */
export interface DateFieldNameOptions {
    type: string;
    nameType: string;
}
